<template>
  <div
    class="flex flex-col rounded-lg shadow-sm bg-white px-5 py-5 max-w-screen-xl mx-auto"
    v-if="getCurrentDocumentSigning"
  >
    <div class="flex flex-row justify-between">
      <div class="flex flex-col">
        <h5 class="text-brand-black text-lg">
          {{ getCurrentDocumentSigning.template.name }}
        </h5>
        <p class="text-brand-mid-gray text-sm py-1 truncate">
          sent by {{ getCurrentDocumentSigning.sent_by }}
        </p>
      </div>
    </div>
  </div>
  <div
    class="flex items-center w-full mt-5 max-w-screen-xl mx-auto"
    v-if="getCurrentDocumentSigning"
  >
    <template v-if="!isAllImageLoaded">
      <div
        tabindex="-1"
        id="modal-bg"
        class="flex items-center justify-center w-full h-screen bg-black opacity-20 top-0 left-0 fixed z-10"
      >
        <Loading class="opacity-100" />
      </div>
    </template>
    <div class="flex items-center w-full panel h-screen py-5">
      <div class="flex w-full h-full relative">
        <div class="flex relative h-full w-2/12" :style="{ height: `${allFileHeight}px` }">
          <div class="" v-if="!started">
            <PrimaryButton @click="start">Start</PrimaryButton>
          </div>
          <div
            class=""
            :style="{ 'margin-top': `${currentCursorHeight}px` }"
            v-if="
              started &&
              getCurrentDocumentSigning.template.overlay[currentFile].fields.length &&
              !completed
            "
          >
            <PrimaryButton @click="goToNextField">Next</PrimaryButton>
          </div>
          <div
            :style="{ 'margin-top': `${allFileHeight - 40}px` }"
            id="finish-button"
            v-if="completed"
          >
            <PrimaryButton
              @click="finish"
              :disabled="isDocumentSigningLoading"
              :isLoading="isDocumentSigningLoading"
              >Finish</PrimaryButton
            >
          </div>
        </div>

        <div class="flex flex-col w-9/12 h-full">
          <div
            class="flex items-center parent my-1 relative"
            v-for="(file, idx) in getCurrentDocumentSigning.template.attachments"
            :key="idx"
            ref="file-render"
            :id="`${file.name}`"
          >
            <template v-if="file.name.split('.').pop() === 'pdf'">
              <VuePdfEmbed
                :source="file.url"
                :width="getCurrentDocumentSigning.overlay.frameWidth"
                @rendered="getCurrentDocumentSigning.overlay[file.name].loaded = true"
                :disableAnnotationLayer="true"
              />
            </template>
            <template v-else>
              <img
                :src="file.url"
                :ref="`rendered-${file.name}`"
                :style="{
                  'max-width': 'none',
                  width: `${getCurrentDocumentSigning.overlay.frameWidth}px`
                }"
                @load="getCurrentDocumentSigning.overlay[file.name].loaded = true"
              />
            </template>
            <template
              v-if="
                getCurrentDocumentSigning.overlay[file.name] &&
                getCurrentDocumentSigning.overlay[file.name].fields &&
                getCurrentDocumentSigning.overlay[file.name].loaded &&
                newOverlay
              "
            >
              <DocumentDraggableField
                :field="mapperData"
                mode="input"
                @set-field="handleInput($event, mapperData)"
                :active="mapperData.active"
                @activated="mapperData.active = true"
                @deactivated="mapperData.active = false"
                :id="`${file.name}-field-${idx}`"
                :ref="`${file.name}-field-${idx}`"
                v-for="(mapperData, idx) in newOverlay[file.name].fields"
                :key="`draggable-${file.name}-${idx}`"
              />
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- <ConsentModal :showModal="showConsentModal" @close="toggleConsentModal" /> -->
</template>
<script>
import _ from "lodash"
import moment from "moment"

import VuePdfEmbed from "vue-pdf-embed"
// import ConsentModal from "./components/ConsentModal.vue"

import { mapGetters } from "vuex"
import { DOCUMENT_SIGNING_SUBMIT } from "@/store/types"
// import { PrinterIcon } from "@heroicons/vue/outline"

export default {
  components: {
    VuePdfEmbed
    // ConsentModal
    // PrinterIcon
  },
  computed: {
    ...mapGetters(["isDocumentSigningLoading", "getCurrentDocumentSigning"]),
    isAllImageLoaded() {
      if (!this.getCurrentDocumentSigning) {
        return false
      }

      const loaded = Object.keys(this.getCurrentDocumentSigning.overlay)
        .map((key) => {
          return this.getCurrentDocumentSigning.overlay[key].loaded
        })
        .filter(Boolean)
      return (
        loaded.length === Object.keys(this.getCurrentDocumentSigning.template.attachments).length
      )
    },
    currentCursorHeight() {
      if (!this.currentField) return 0

      const currentFileIdx = _.findIndex(
        this.getCurrentDocumentSigning.template.attachments,
        (at) => at.name === this.currentFile
      )

      let height = 0

      const completedFileHeight = this.getCurrentDocumentSigning.template.attachments
        .map((at) => {
          const idx = this.getCurrentDocumentSigning.template.attachments.indexOf(at)

          if (idx < currentFileIdx) {
            return document.getElementById(at.name).clientHeight
          }
        })
        .filter(Boolean)
        .reduce((acc, val) => acc + val, 0)

      height = completedFileHeight + this.currentField.y

      return height
    },
    allFieldCount() {
      if (!this.getCurrentDocumentSigning) {
        return 0
      }
      const count = this.getCurrentDocumentSigning.template.attachments
        .map((at) => {
          return this.newOverlay[at.name].fields.filter(
            (f) => !["text_display", "mappable"].includes(f.type)
          ).length
        })
        .reduce((acc, val) => acc + val, 0)
      return count
    },
    allFileHeight() {
      if (!this.isAllImageLoaded) return 0

      const allHeight = this.$refs["file-render"]
        .map((el) => el.clientHeight)
        .reduce((acc, val) => acc + val, 0)
      return allHeight
    },
    invalidFields() {
      const invalidFields = []
      if (!this.getCurrentDocumentSigning) return invalidFields

      this.getCurrentDocumentSigning.template.attachments.forEach((at) => {
        this.newOverlay[at.name].fields.forEach((f) => {
          if (f.required && !f.value) {
            const idx = _.findIndex(this.newOverlay[at.name].fields, (field) => field === f)
            invalidFields.push({ file: at.name, idx })
          }
        })
      })
      return invalidFields
    }
  },
  mounted() {
    // this.toggleConsentModal()
    const { id } = this.$route.params
    this.id = id

    if (this.$route.query.t) {
      this.token = this.$route.query.t
    }
  },
  data() {
    return {
      id: "",
      token: "",
      // showConsentModal: false,
      newOverlay: null,
      started: false,
      completed: false,
      currentFieldIdx: 0,
      currentFile: "",
      currentField: null
    }
  },
  watch: {
    getCurrentDocumentSigning: {
      handler(val) {
        if (val) {
          this.newOverlay = {}

          const clonedOverlay = _.cloneDeep(val.overlay)
          val.template.attachments.forEach((at) => {
            if (!clonedOverlay[at.name].fields.length) {
              this.newOverlay[at.name] = { fields: [] }
            } else {
              clonedOverlay[at.name].fields.forEach((f) => {
                console.log(f)
                if (!f.value) {
                  if (!this.newOverlay[at.name]) {
                    this.newOverlay[at.name] = { fields: [] }
                  }

                  if (
                    f.user_type === "all" ||
                    [f.user_type, "default"].includes(this.getCurrentDocumentSigning.signer.type)
                  ) {
                    this.newOverlay[at.name].fields.push(f)
                  }
                }
              })
            }
          })

          this.currentFile = this.getCurrentDocumentSigning.template.attachments[0].name
        }
      }
    }
  },
  methods: {
    // toggleConsentModal() {
    //   this.showConsentModal = !this.showConsentModal
    // },
    handleInput(field, mapperData) {
      Object.keys(field).forEach((key) => {
        mapperData[key] = field[key]
      })
      mapperData.timestamp = moment().unix()
    },
    setCurrentFieldActive() {
      this.currentField.active = true
    },
    scrollToCurrentField() {
      document.getElementById(`${this.currentFile}-field-${this.currentFieldIdx}`).scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "center"
      })
    },

    goToNextField() {
      if (!this.allFieldCount) {
        this.completed = true
      } else if (!this.currentField) {
        this.currentFile = this.getCurrentDocumentSigning.template.attachments[0].name
        this.currentFieldIdx = 0
      } else {
        if (this.newOverlay[this.currentFile].fields.length - 1 === this.currentFieldIdx) {
          const currentFileIdx = _.findIndex(
            this.getCurrentDocumentSigning.template.attachments,
            (at) => at.name === this.currentFile
          )

          if (this.getCurrentDocumentSigning.template.attachments.length - 1 === currentFileIdx) {
            this.completed = true
          } else {
            const nextFileIdx = currentFileIdx + 1
            this.currentFile = this.getCurrentDocumentSigning.template.attachments[nextFileIdx].name
            this.currentFieldIdx = 0
          }
        } else {
          this.currentFieldIdx = this.currentFieldIdx + 1
        }
      }

      if (!this.completed) {
        this.currentField = this.newOverlay[this.currentFile].fields[this.currentFieldIdx]

        if (!this.currentField) {
          this.completed = true
          this.$nextTick(() => {
            document.getElementById("finish-button").scrollIntoView({
              behavior: "smooth"
            })
          })
          return
        }

        if (["text_display", "mappable"].includes(this.currentField.type)) {
          this.goToNextField()
          return
        }

        this.setCurrentFieldActive()
        this.$nextTick(() => {
          this.scrollToCurrentField()
        })
      } else {
        this.$nextTick(() => {
          document.getElementById("finish-button").scrollIntoView({
            behavior: "smooth"
          })
        })
      }
    },
    goToFirstInvalidField() {
      if (!this.invalidFields.length) {
        return
      }
      this.completed = false

      this.currentFile = this.invalidFields[0].file
      this.currentFieldIdx = this.invalidFields[0].idx
      this.currentField = this.newOverlay[this.currentFile].fields[this.currentFieldIdx]

      this.setCurrentFieldActive()
      this.$nextTick(() => {
        this.scrollToCurrentField()
      })
    },
    start() {
      this.started = true
      this.goToNextField()
    },
    async finish() {
      const { id, token, newOverlay } = this
      if (this.invalidFields.length) {
        //TODO: Go to first invalid field index
        this.goToFirstInvalidField()
        return
      }

      try {
        await this.$store.dispatch(DOCUMENT_SIGNING_SUBMIT, { id, token, overlay: newOverlay })
        this.$router.push({ name: "signing_complete", query: { t: token } })
      } catch (err) {
        console.log(err)
      }
    }
  }
}
</script>
<style scoped>
.panel {
  max-height: 80vh;
  overflow-y: scroll;
}
@media (max-width: 768px) {
  .panel {
    max-height: 100vh;
  }
}
</style>
